import type { FilterModel } from '@repo/table/filters'

export interface BuildLoadsUrlOptions {
  columnId:
    | 'any_carrier_company_id'
    | 'any_customer_company_id'
    | 'company_id'
    | 'haulier_company_id'
  company: LoadsUrlCompany
  /** `uncancelled` is the All tab without cancelled loads, as the company statistics count them. */
  scope: 'active' | 'completed' | 'uncancelled'
}

export interface LoadsUrlCompany {
  id: number
  title: string
}

export const buildLoadsUrl = ({ columnId, company, scope }: BuildLoadsUrlOptions) => {
  const companyFilter: FilterModel<'company'> = {
    columnId,
    operator: 'is',
    type: 'company',
    values: [{ label: company.title, value: company.id.toString() }],
  }

  if (scope === 'active') {
    const filters = JSON.stringify([companyFilter])

    return `/loads?status=active&filters=${encodeURIComponent(filters)}`
  }

  const statusFilter: FilterModel<'multiOption'> =
    scope === 'completed'
      ? {
          columnId: 'status',
          operator: 'include',
          type: 'multiOption',
          values: ['completed', 'archived'],
        }
      : { columnId: 'status', operator: 'exclude', type: 'multiOption', values: ['cancelled'] }

  const filters = JSON.stringify([companyFilter, statusFilter])

  return `/loads?status=all&filters=${encodeURIComponent(filters)}`
}
